var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 91,
    height: 91,
    rx: 10,
    fill: "#E9D5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9566 45.4783C77.9566 46.7358 77.8699 47.95 77.7398 49.1641C75.962 65.3382 62.2161 78 45.4783 78C28.7405 78 14.9947 65.3382 13.2168 49.1641C13.0867 47.95 13 46.7358 13 45.5217C13.0434 27.5264 27.5264 13 45.4783 13C63.4303 13 77.9133 27.5264 77.9566 45.4783Z",
    fill: "#E9D5FG"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9566 45.4783C77.9566 46.7358 77.8699 47.95 77.7398 49.1641C73.1868 49.2075 65.9019 49.4243 63.994 49.2075C63.0834 49.1208 62.4763 48.427 62.3896 47.5164C62.0427 43.397 62.6931 38.8006 62.3896 34.6378C62.2161 31.9927 59.5277 31.4723 58.6604 33.9006C58.3569 40.6218 59.0507 47.7332 58.6604 54.411C58.2268 62.1294 48.6004 62.5631 47.3429 55.3216V28.3069C46.8659 26.1388 43.8306 26.2689 43.6137 28.4803V62.8666C42.2695 70.1081 32.6865 69.5877 32.2962 61.9126C31.9059 54.541 32.5997 46.8659 32.2962 39.4944C31.5157 37.1528 28.7405 37.5864 28.567 40.1448C28.3936 42.5297 28.8706 45.435 28.567 47.7332C28.437 48.5571 27.6998 49.1208 26.8759 49.2075C24.9246 49.4243 17.5964 49.2075 13.2168 49.1641C13.0867 47.95 13 46.7358 13 45.5217L24.8379 45.4783V39.3643C24.8379 37.7599 26.3122 35.7652 27.6998 34.9847C31.5157 32.8166 35.982 35.5484 36.1554 39.7979V62.7799C36.8492 64.9046 39.7111 64.6011 39.8846 62.3463V28.0467C40.7952 21.3256 50.2048 21.3256 51.072 28.0467V54.8446C51.2455 57.0994 54.3242 57.403 54.8012 55.1915V34.2042C54.9747 29.7812 59.7445 27.0494 63.5604 29.521C64.7745 30.3016 66.1187 32.2962 66.1187 33.7705V45.4783H77.9566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/mainLogo.ee1a39d57f19f6c3d04cf789115c9910.svg";
export { ForwardRef as ReactComponent };